
import React from 'react';
import {
  Svg,
  Circle,
  Ellipse,
  G,
  LinearGradient,
  RadialGradient,
  Line,
  Path,
  Polygon,
  Polyline,
  Rect,
  Symbol,
  Text,
  Use,
  Defs,
  Stop
} from 'react-native-svg';

export default function CashMoney(props) {
  return (
    <Svg height="64px" id="Layer_1" width="64px" version="1.1" viewBox="0 0 64 64" xmlSpace="preserve"  {...props}>
    	<G id="Designs">
    		<G>
    			<Rect height="22" width="44" fill="#69F0AE" x="6" y="12"/>
    		</G>
    		<G>
    			<Path d="M14.473,30c-0.231-2.083-1.891-3.741-3.973-3.973v-7.055c2.082-0.231,3.741-1.89,3.973-3.973h27.055        c0.231,2.083,1.891,3.741,3.973,3.973v7.055c-2.082,0.231-3.741,1.89-3.973,3.973H14.473z" fill="#B9F6CA"/>
    		</G>
    		<G>
    			<Path d="M41.101,16c0.398,1.956,1.943,3.501,3.899,3.899v6.201c-1.956,0.398-3.501,1.943-3.899,3.899H14.899        c-0.398-1.956-1.943-3.501-3.899-3.899v-6.201c1.956-0.398,3.501-1.943,3.899-3.899H41.101L41.101,16z M42,15H14  c0,2.21-1.791,4-4,4v8c2.209,0,4,1.79,4,4h28c0-2.21,1.791-4,4-4v-8C43.791,19,42,17.21,42,15L42,15z" fill="#00C853"/>
    		</G>
    	</G>
    	<G>
    		<G>
    			<Path d="M28,20c0.719,0,1,0.521,1,1h2c0-0.814-0.674-1.619-2-1.894V18h-2v1.092c-1.326,0.24-2,1.009-2,2.408       c0,1.313,1.031,2.5,3,2.5c0.577,0,1,0.438,1,1c0,0.595-0.334,1-1,1s-1-0.367-1-1h-2c0,1.245,0.684,1.78,2,1.94V28h2v-1.075       c1.326-0.2,2.025-0.874,2-2.425c0-1.375-1-2.499-3-2.499c-0.563,0-1-0.313-1-1.001C27,20.482,27.281,20,28,20z" fill="#00C853"/>
    		</G>
    		<G>
    			<Path d="M39,21.5c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S38.172,21.5,39,21.5L39,21.5z      M39,20.5c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5s2.5-1.121,2.5-2.5S40.379,20.5,39,20.5L39,20.5z" fill="#00C853"/>
    		</G>
    		<G>
    			<Path d="M17,21.5c0.828,0,1.5,0.672,1.5,1.5s-0.672,1.5-1.5,1.5s-1.5-0.672-1.5-1.5S16.172,21.5,17,21.5L17,21.5z      M17,20.5c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5s2.5-1.121,2.5-2.5S18.379,20.5,17,20.5L17,20.5z" fill="#00C853"/>
    		</G>
    	</G>
    </Svg>
  );
}
